import React from 'react'
import {TableRow, TableCell} from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

const TableRowsLoader = ({ rowsNum, colsNum }) => {
  const totalRows = Number.isFinite(rowsNum) ? rowsNum : 0;
  const totalCols = Number.isFinite(colsNum) ? colsNum : 0;

  return [...Array(totalRows)].map((_, rowIndex) => (
    <TableRow key={`loader-row-${rowIndex}`}>
      {[...Array(totalCols)].map((_, colIndex) => (
        <TableCell key={`loader-cell-${rowIndex}-${colIndex}`} component="th" scope="row">
        <Skeleton animation="wave" variant="text" />
      </TableCell>
      ))}
    </TableRow>
  ));
}

export default TableRowsLoader